import { AuthenticatedUser } from '~/Api/Authentication';

import logGoogleTagManagerEvent from './logGoogleTagManagerEvent';

export default function logGoogleTagManagerUser(user: AuthenticatedUser | null) {
	logGoogleTagManagerEvent({
		event: 'cogvio.currentUser',
		currentUser: user
			? {
					id: user.id,
					email: user.email,
					name: user.name,
					customer: {
						id: user.customer.id,
						name: user.customer.name,
					},
			  }
			: null,
	});
}
